<h1 class="header list-header astral-heading-with-help">
  <span>{{ 'VACANT_RENTAL_OBJECT_LIST.OTHER_RENTAL_OBJECT_HEADER' | translate }}</span>
  <astral-popover [helpText]="'VACANT_RENTAL_OBJECT_LIST.HEADER_TOOLTIP'"></astral-popover>
</h1>

<app-list-view
  [columnDefinition]="columnDefinition"
  [contextMenuDefinition]="menuDefinition"
  [itemsSource]="itemsSource"
  [preferencesKey]="'rent.vacant-other-rental-object.list'"
  (rowClick)="onRowClicked($event)"
></app-list-view>
